/**
 *
 * @module priceOrderResponse
 *
 */

import Check from 'check-types';

import OrderItem from './orderItem';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    array,
    number,
    string,
    nonEmptyObject,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class PriceOrderResponse
 *
 */
export default class PriceOrderResponse {

    /**
     *
     * @param {Object} options
     * @param {String} [options.region]
     * @param {Number} options.orderSubTotal
     * @param {Number} options.orderTaxAmount
     * @param {Number} options.orderTotalAmount
     * @param {?String} [options.nextBillingDate]
     * @param {Array<SDK.Services.Commerce.OrderItem>} options.orderItems
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'PriceOrderResponse(options)',
            get options() {
                return `${this.ctor} options should be non-empty Object`;
            },
            get region() {
                return `${this.ctor} options.region should be a String with length`;
            },
            get orderSubTotal() {
                return `${this.ctor} options.orderSubTotal should be a Number`;
            },
            get orderTaxAmount() {
                return `${this.ctor} options.orderTaxAmount should be a Number`;
            },
            get orderTotalAmount() {
                return `${this.ctor} options.orderTotalAmount should be a Number`;
            },
            get nextBillingDate() {
                return `${this.ctor} options.nextBillingDate should be a String`;
            },
            get orderItems() {
                return `${this.ctor} needs Array of SDK.Services.Commerce.OrderItem instances`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { region, orderSubTotal, orderTaxAmount, orderTotalAmount, nextBillingDate, orderItems } = options;

        if (Check.assigned(region)) {
            nonEmptyString(region, errorMessage.region, InvalidArgumentException);
        }

        number(orderSubTotal, errorMessage.orderSubTotal, InvalidArgumentException);
        number(orderTaxAmount, errorMessage.orderTaxAmount, InvalidArgumentException);
        number(orderTotalAmount, errorMessage.orderTotalAmount, InvalidArgumentException);

        if (Check.assigned(nextBillingDate)) {
            string(nextBillingDate, errorMessage.nextBillingDate, InvalidArgumentException);
        }

        array.of.instanceStrict(orderItems, OrderItem, errorMessage.orderItems, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {String|undefined|null}
         * @desc Contains the region which is to be used when calling createPaymentMethod to lookup which
         * createPaymentMethod endpoint to use.
         * @note This value comes from the `x-bamtech-region` response header.
         * @note The spec states this should be `null` if not provided but to the JS SDK `undefined` and `null`
         * provide the same result and prevent this from being used when attempting to retrieve a region specific
         * endpoint in the `CommerceClient`
         *
         */
        this.region = region;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.orderSubTotal = orderSubTotal;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.orderTaxAmount = orderTaxAmount;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.orderTotalAmount = orderTotalAmount;

        /**
         *
         * @access public
         * @type {String|undefined|null}
         *
         */
        this.nextBillingDate = nextBillingDate;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Commerce.OrderItem>}
         *
         */
        this.orderItems = orderItems;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/priceOrderResponse.js